import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f895bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "module contact" }
const _hoisted_2 = { class: "module-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "联系我们", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-subTitle" }, " 若您对爱乐云产品有任何疑问，请联系我们，我们将详细为您解答 ", -1))
const _hoisted_5 = { class: "contact-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "mapContainer" }, null, -1))
const _hoisted_7 = { class: "company" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "company-item" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "咨询热线：15728562024", -1))
const _hoisted_13 = { class: "company-item" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电子邮箱：wu73@lspace.vip", -1))
const _hoisted_16 = { class: "company-item" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫码添加顾问微信", -1))

export function render(_ctx: any,_cache: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["company-item pointer", item.select ? 'theme' : '']),
              onClick: ($event: any) => (_ctx.onClick(index))
            }, [
              _createElementVNode("img", {
                class: "company-icon",
                src: 
                                require(`@/assets/images/contact/${item.icon}.png`)
                            
              }, null, 8, _hoisted_9),
              _createElementVNode("span", null, _toDisplayString(item.addr), 1)
            ], 10, _hoisted_8))
          }), 128)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "company-icon",
              src: require('@/assets/images/contact/phone.png')
            }, null, 8, _hoisted_11),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("img", {
              class: "company-icon",
              src: require('@/assets/images/contact/mail.png')
            }, null, 8, _hoisted_14),
            _hoisted_15
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              class: "qrCode",
              src: require('@/assets/images/workerCode250212.png')
            }, null, 8, _hoisted_17),
            _hoisted_18
          ])
        ])
      ])
    ])
  ]))
}